import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROLS].GET_REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROLS]: {
		url:'/company/:companyId/regulations/:regulationId/stages/:stageId/plan_works/:planWorkId/quality_control/',
	},
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROLS].GET_REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROL_PREVIEW]: {
		url: '/company/:companyId/regulations/:regulationId/stages/:stageId/plan_works/:planWorkId/quality_control/:qualitiControlId/preview/',
	},
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROLS].GET_REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROL_POPUP]: {
		url: '/company/:companyId/regulations/:regulationId/stages/:stageId/plan_works/:planWorkId/quality_control/:qualitiControlId/popup/',
	},
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROLS].GET_REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROL]: {
		url: '/company/:companyId/regulations/:regulationId/stages/:stageId/plan_works/:planWorkId/quality_control/:qualitiControlId/',
	},
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROLS].CREATE_REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROL]: {
		url:'/company/:companyId/regulations/:regulationId/stages/:stageId/plan_works/:planWorkId/quality_control/',
		requestOptions: {
			method: 'POST',
		},
	},
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROLS].PATCH_REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROL]: {
		url: '/company/:companyId/regulations/:regulationId/stages/:stageId/plan_works/:planWorkId/quality_control/:qualitiControlId/',
		requestOptions: {
			method: 'PATCH',
		},
	},
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROLS].PUT_REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROL]: {
		url: '/company/:companyId/regulations/:regulationId/stages/:stageId/plan_works/:planWorkId/quality_control/:qualitiControlId/',
		requestOptions: {
			method: 'PUT',
		},
	},
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROLS].DELETE_REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROL]: {
		url: '/company/:companyId/regulations/:regulationId/stages/:stageId/plan_works/:planWorkId/quality_control/:qualitiControlId/',
		requestOptions: {
			method: 'DELETE',
		},
	},
}